module.exports = __webpack_public_path__ + "static/media/data-cleancing.eeeaf684.jpg";